var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drag-item",class:{ 'drag-item--success': _vm.success, 'full-size': _vm.applyStyles }},[(_vm.isUrl(_vm.element))?_c('img',{attrs:{"src":_vm.element}}):_c('span',{attrs:{"title":_vm.element}},[_vm._v(_vm._s(_vm.element))])])
}
var staticRenderFns = []

export { render, staticRenderFns }